export const camelToSnake = (str: string): string =>
	str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
